import React from "react";
import pregameIcon from "../../assets/hasPregame.svg";

const PregameBadge = () => (
    <div className="pregameBadge">
        <img src={pregameIcon} alt="Has pregame" />
    </div>
);

export default PregameBadge;
